<template>
  <div>
    <v-overlay :value="loading" opacity="0.7">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
      <v-card-text class="pb-0">
        <v-subheader class="font-weight-bold pt-2 pb-2">
          Informações do Veículo
        </v-subheader>
        <v-container fluid>
          <v-divider class="pb-4" />
          <v-row>
            <v-col cols="12" md="8" class="py-0">
              <v-row>
                <v-col class="py-0" cols="6" md="3">
                  <v-text-field
                    :error-messages="errors.ano"
                    :rules="rules.ano"
                    class="pa-0"
                    dense
                    label="Ano *"
                    outlined
                    v-model="formData.ano"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" md="4">
                  <v-text-field
                    :error-messages="errors.placa"
                    :rules="rules.placa"
                    class="pa-0"
                    dense
                    label="Placa *"
                    outlined
                    v-model="formData.placa"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" md="5">
                  <v-text-field
                    counter="30"
                    :error-messages="errors.renavam"
                    :rules="rules.renavam"
                    class="pa-0"
                    dense
                    label="Renavam"
                    outlined
                    v-model="formData.renavam"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="py-0" cols="6" md="2">
              <v-switch label="Ativo?" v-model="formData.ativo"></v-switch>
            </v-col>
            <v-col class="py-0" cols="6" md="2">
              <v-switch label="Importado?" v-model="formData.importado"></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" md="4" cols="12">
              <v-autocomplete
                label="Marcas"
                v-model="formData.marca_id"
                :items="marcas"
                :search-input.sync="searchMarcasAutoComplete"
                outlined
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                :aria-autocomplete="false"
                clearable
                dense
                :rules="rules.marca_id"
                :error-messages="errors.marca_id"
                :loading="isloadingMarcas"
                @change="loadModelos"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" md="4" cols="12">
              <v-autocomplete
                label="Modelos"
                v-model="formData.modelo_id"
                :items="modelos"
                :search-input.sync="searchModelosAutoComplete"
                outlined
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                :aria-autocomplete="false"
                clearable
                dense
                :rules="rules.modelo_id"
                :error-messages="errors.modelo_id"
                :loading="isloadingModelos"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" md="4" cols="12">
              <v-autocomplete
                label="Cores"
                v-model="formData.cor_id"
                :items="cores"
                :search-input.sync="searchCoresAutoComplete"
                outlined
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                :aria-autocomplete="false"
                clearable
                dense
                :rules="rules.cor_id"
                :error-messages="errors.cor_id"
                :loading="isloadingCores"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
        <v-subheader class="font-weight-bold pt-2 pb-2">
          Detalhes do Veículo
        </v-subheader>
        <v-container fluid>
          <v-row>
            <v-col class="py-0" cols="6">
              <v-autocomplete
                label="Categorias"
                v-model="formData.categoria_id"
                :items="categorias"
                :search-input.sync="searchCategoriasAutoComplete"
                outlined
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                :aria-autocomplete="false"
                clearable
                dense
                :rules="rules.categoria_id"
                :error-messages="errors.categoria_id"
                :loading="isloadingCategorias"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" cols="6">
              <v-autocomplete
                label="Vínculo"
                v-model="formData.vinculo_id"
                :items="vinculos"
                :search-input.sync="searchVinculosAutoComplete"
                outlined
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                :aria-autocomplete="false"
                clearable
                dense
                :rules="rules.vinculo_id"
                :error-messages="errors.vinculo_id"
                :loading="isloadingVinculos"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" cols="12">
              <v-autocomplete
                :error-messages="errors.combustiveis"
                :items="combstiveis"
                :loading="isloadingCombustiveis"
                :rules="rules.combustiveis"
                chips
                small-chips
                clearable
                dense
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                label="Combustivel"
                multiple
                outlined
                persistent-hint
                placeholder="Selecione os combustiveis desejados"
                v-model="formData.combustiveis"
              >
                <template v-slot:selection="data">
                  <v-chip
                    :input-value="data.selected"
                    @click="data.select"
                    @click:close="removeCombustivel(data.item)"
                    close
                    v-bind="data.attrs"
                  >
                    {{ data.item.nome }}
                  </v-chip>
                </template>

                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.nome }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12">
              <v-textarea
                :error-messages="errors.observacao"
                class="pa-0"
                dense
                label="Observação"
                outlined
                v-model="formData.observacao"
                rows="2"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-container>
        <v-subheader class="font-weight-bold pt-2 pb-2">
          Estado de Conservação do Veículo
        </v-subheader>
        <v-container fluid>
          <v-row>
            <v-col class="py-0" md="3" cols="6">
              <v-autocomplete
                label="Estado Pintura"
                v-model="formData.estado_pintura_id"
                :items="estadosConservacao"
                :search-input.sync="searchEstadoPinturaAutoComplete"
                outlined
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                :aria-autocomplete="false"
                clearable
                dense
                :rules="rules.estado_pintura_id"
                :error-messages="errors.estado_pintura_id"
                :loading="isloadingEstados"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" md="3" cols="6">
              <v-autocomplete
                label="Estado Pneu"
                v-model="formData.estado_pneu_id"
                :items="estadosConservacao"
                :search-input.sync="searchEstadoPneuAutoComplete"
                outlined
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                :aria-autocomplete="false"
                clearable
                dense
                :rules="rules.estado_pneu_id"
                :error-messages="errors.estado_pneu_id"
                :loading="isloadingEstados"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" md="3" cols="6">
              <v-autocomplete
                label="Estado Mecanica"
                v-model="formData.estado_mecanica_id"
                :items="estadosConservacao"
                :search-input.sync="searchEstadoMecanicaAutoComplete"
                outlined
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                :aria-autocomplete="false"
                clearable
                dense
                :rules="rules.estado_mecanica_id"
                :error-messages="errors.estado_mecanica_id"
                :loading="isloadingEstados"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" md="3" cols="6">
              <v-autocomplete
                label="Estado Geral"
                v-model="formData.estado_geral_id"
                :items="estadosConservacao"
                :search-input.sync="searchEstadoGeralAutoComplete"
                outlined
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                :aria-autocomplete="false"
                clearable
                dense
                :rules="rules.estado_geral_id"
                :error-messages="errors.estado_geral_id"
                :loading="isloadingEstados"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="py-2 px-4">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid"
          :loading="isloadingSubmit"
          color="green"
          dark
          depressed
          type="submit"
        >
          <v-icon left small>mdi-send</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { max, required } from '@/services/util/validate';
import marcaHttp from '@/services/http/resources/frota/marcaHttp';
import modeloHttp from '@/services/http/resources/frota/modeloHttp';
import corHttp from '@/services/http/resources/frota/corHttp';
import estadoHttp from '@/services/http/resources/frota/estadoHttp';
import categoriaHttp from '@/services/http/resources/frota/categoriaHttp';
import vinculoHttp from '@/services/http/resources/frota/vinculoHttp';
import combustivelHttp from '@/services/http/resources/frota/combustivelHttp';
import toastMessage from '@/services/util/alertService';

export default {
  name: 'VeiculoForm',
  metaInfo: {
    title: 'Veículo',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Adicionar Veículo',
    valid: true,
    marcas: [],
    modelos: [],
    cores: [],
    estadosConservacao: [],
    categorias: [],
    vinculos: [],
    combstiveis: [],
    formData: {
      id: '',
      placa: '',
      ano: '',
      renavam: '',
      ativo: false,
      importado: false,
      observacao: '',
      marca_id: '',
      modelo_id: '',
      cor_id: '',
      categoria_id: '',
      vinculo_id: '',
      estado_pintura_id: '',
      estado_pneu_id: '',
      estado_mecanica_id: '',
      estado_geral_id: '',
      combustiveis: [],
    },
    formDataDefault: {
      id: '',
      placa: '',
      ano: '',
      renavam: '',
      ativo: false,
      importado: false,
      observacao: '',
      marca_id: '',
      modelo_id: '',
      cor_id: '',
      categoria_id: '',
      vinculo_id: '',
      estado_pintura_id: '',
      estado_pneu_id: '',
      estado_mecanica_id: '',
      estado_geral_id: '',
      combustiveis: [],
    },
    rules: {
      ano: [required, (value) => max(value, 200)],
      placa: [required, (value) => max(value, 200)],
      renavam: [(value) => max(value, 30)],
    },
    errors: {
      ano: [],
      placa: [],
      renavam: [],
    },
    loading: false,
    isloadingSubmit: false,
    isloadingMarcas: false,
    isloadingModelos: false,
    isloadingCores: false,
    isloadingEstados: false,
    isloadingCategorias: false,
    isloadingVinculos: false,
    isloadingCombustiveis: false,
    searchMarcasAutoComplete: '',
    searchModelosAutoComplete: '',
    searchCoresAutoComplete: '',
    searchEstadoPinturaAutoComplete: '',
    searchEstadoPneuAutoComplete: '',
    searchEstadoMecanicaAutoComplete: '',
    searchEstadoGeralAutoComplete: '',
    searchCategoriasAutoComplete: '',
    searchVinculosAutoComplete: '',
    searchCombustiveisAutoComplete: '',
  }),
  computed: {
    ...mapState('veiculo', ['dataIndex', 'data']),
  },
  created() {
    this.checkEdit();
  },
  methods: {
    ...mapActions('veiculo', ['edit', 'store', 'update', 'clearData', 'reset', 'setDataIndex']),
    checkEdit() {
      this.loadAll().then(() => {
        if (this.$route.params.id) {
          this.edit({ id: this.$route.params.id }).then(() => {
            this.openDialogForm();
          });
        }
      });
    },
    openDialogForm() {
      Object.entries(this.formDataDefault).forEach(([key]) => {
        if (key === 'marca_id') {
          this.formData[key] = this.data.modelo.marca_id;
          this.loadModelos();
        } else if (key === 'combustiveis' && this.data[key]) {
          this.formData[key] = this.data[key].map((item) => item.id);
        } else {
          this.formData[key] = this.data[key];
        }
      });
    },
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.resetValidation();
        this.clearData();
        this.setDataIndex(-1);
      }, 300);
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isloadingSubmit = true;
        const actionHttp = !this.$route.params.id
          ? this.store(this.formData)
          : this.update(this.formData);
        actionHttp
          .then(({ data: { data } }) => {
            if (!this.$route.params.id) {
              this.$router.push({ name: 'frota.veiculo.editar', params: { id: data.id } });
            }
            toastMessage.successSave('Veículo salvo com sucesso');
            this.resetValidation();
          })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors).forEach(([index, value]) => {
                this.errors[index].push(value.toString());
                toastMessage.errorValidation();
              });
            } else {
              toastMessage.errorSave('Erro ao salvar veículo');
            }
          })
          .finally(() => {
            this.isloadingSubmit = false;
          });
      }
    },
    removeCombustivel(item) {
      const index = this.formData.combustiveis.indexOf(item.id);
      if (index >= 0) this.formData.combustiveis.splice(index, 1);
    },
    async loadAll() {
      this.loading = true;
      await Promise.all([
        this.loadMarcas(),
        this.loadCores(),
        this.loadEstadosConservacao(),
        this.loadCategorias(),
        this.loadVinculos(),
        this.loadCombustiveis(),
      ])
        .catch(() => {
          toastMessage.errorLoading('Erro ao carregar dados.');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async loadMarcas() {
      this.isloadingMarcas = true;
      await marcaHttp
        .list()
        .then(({ data: { data } }) => {
          this.marcas = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Marcas'))
        .finally(() => {
          this.isloadingMarcas = false;
        });
    },
    async loadModelos() {
      if (!this.formData.marca_id) return;
      this.isloadingModelos = true;
      await modeloHttp
        .list(this.formData.marca_id)
        .then(({ data: { data } }) => {
          this.modelos = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Modelos'))
        .finally(() => {
          this.isloadingModelos = false;
        });
    },
    async loadCores() {
      this.isloadingCores = true;
      await corHttp
        .list()
        .then(({ data: { data } }) => {
          this.cores = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Cores'))
        .finally(() => {
          this.isloadingCores = false;
        });
    },
    async loadEstadosConservacao() {
      this.isloadingEstados = true;
      await estadoHttp
        .list()
        .then(({ data: { data } }) => {
          this.estadosConservacao = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Estados de Conservação'))
        .finally(() => {
          this.isloadingEstados = false;
        });
    },
    async loadCategorias() {
      this.isloadingCategorias = true;
      await categoriaHttp
        .list()
        .then(({ data: { data } }) => {
          this.categorias = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Categorias'))
        .finally(() => {
          this.isloadingCategorias = false;
        });
    },
    async loadVinculos() {
      this.isloadingVinculos = true;
      await vinculoHttp
        .list()
        .then(({ data: { data } }) => {
          this.vinculos = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Vínculos'))
        .finally(() => {
          this.isloadingVinculos = false;
        });
    },
    async loadCombustiveis() {
      this.isloadingCombustiveis = true;
      await combustivelHttp
        .list()
        .then(({ data: { data } }) => {
          this.combstiveis = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Combustíveis'))
        .finally(() => {
          this.isloadingCombustiveis = false;
        });
    },
    resetEstadosAutoComplete() {
      this.formData.estado = '';
      this.searchEstadosAutoComplete = null;
    },
    resetCidadesAutoComplete() {
      this.cidades = [];
      this.formData.cidade_id = '';
      this.searchCidadesAutoComplete = null;
    },
  },
  watch: {
    'formData.nome': function () {
      this.errors.nome = [];
    },
  },
  destroyed() {
    this.closeDialog();
    this.reset();
  },
};
</script>
